import { FieldArray } from 'react-final-form-arrays';
import { Grid } from '@mui/material';

import { useCanEditFormFieldsContext } from '@occc-app/App/CanEditFormFieldsContext';
import {
  IconButton,
  Typography,
  AddIcon,
  DeleteIcon,
  TextField,
  ProductGroupSelectField,
} from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

const MIN_VARIETY_PURCHASE_CONFIGS = 1;

export const VarietyDiscountPurchasesConfiguration = () => {
  const { isEditable } = useCanEditFormFieldsContext();

  return (
    <>
      <Typography variant='subtitle1' paragraph>
        When They Purchase
      </Typography>
      <FieldArray name='varietyDiscount.purchases'>
        {({ fields }) => {
          const handleAddItem = () => {
            fields.push({});
          };

          return (
            <>
              {fields.map((fieldArrayName, index) => {
                const thresholdName = `${fieldArrayName}.purchaseThreshold`;
                const thresholdLabel = 'Threshold';

                const handleRemoveItem = () => {
                  fields.remove(index);
                };

                const isLastItem = index === (fields.length || 0) - 1;
                const mb = isLastItem ? undefined : 2;

                const isAddActionShown = index === (fields.length || 1) - 1 && isEditable;
                const isDeleteActionShown =
                  isEditable && (fields.length ?? 0) > MIN_VARIETY_PURCHASE_CONFIGS;

                return (
                  <Grid container spacing={2} key={fieldArrayName} mb={mb}>
                    <Grid item sm={2}>
                      <TextField
                        name={thresholdName}
                        label={thresholdLabel}
                        type='number'
                        fieldProps={{
                          parse: parseNumber,
                        }}
                      />
                    </Grid>
                    <Grid item sm={8}>
                      <ProductGroupSelectField
                        inputProps={{
                          margin: 'none',
                        }}
                        name={`${fieldArrayName}.eligibleProductGroups`}
                        label='Product groups'
                      />
                    </Grid>
                    <Grid item sm={2}>
                      {isDeleteActionShown && (
                        <IconButton onClick={handleRemoveItem} size='medium' sx={{ mt: 1 }}>
                          <DeleteIcon color='error' fontSize='inherit' />
                        </IconButton>
                      )}
                      {isAddActionShown && (
                        <IconButton onClick={handleAddItem} size='medium' sx={{ mt: 1 }}>
                          <AddIcon fontSize='inherit' />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
            </>
          );
        }}
      </FieldArray>
    </>
  );
};
